// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.itinerary-details-card-wrapper input {
  display: none;
}
.itinerary-details-card-wrapper label {
  position: relative;
  cursor: pointer;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.03em;
}
.itinerary-details-card-wrapper label:before {
  content: "";
  appearance: none;
  -webkit-appearance: none;
  background-color: transparent;
  border: 1px solid #c2c2c2;
  border-radius: 2px;
  padding: 8px;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  cursor: pointer;
}
.itinerary-details-card-wrapper input:checked + label:before {
  border: 1px solid #92278f;
}
.itinerary-details-card-wrapper input:checked + label:after {
  content: "";
  display: block;
  position: absolute;
  top: 3px;
  left: 7px;
  width: 5px;
  height: 10px;
  border: solid #92278f;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}
.itinerary-details-card-wrapper .route-name {
  padding-left: 0;
}

.itinerary-details-card-wrapper:has(input:checked) {
  background-color: #f8f7f7 !important;
  border: 1px solid #92278f !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/AddLeads/stepTwo/Components/ItineraryDetailsCard.scss"],"names":[],"mappings":"AACI;EACI,aAAA;AAAR;AAGI;EACI,kBAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;EACA,sBAAA;AADR;AAII;EACI,WAAA;EACA,gBAAA;EACA,wBAAA;EACA,6BAAA;EACA,yBAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,kBAAA;EACA,sBAAA;EACA,eAAA;AAFR;AAKI;EACI,yBAAA;AAHR;AAMI;EACI,WAAA;EACA,cAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,UAAA;EACA,YAAA;EACA,qBAAA;EACA,yBAAA;EACA,wBAAA;AAJR;AAOI;EACI,eAAA;AALR;;AASA;EACI,oCAAA;EACA,oCAAA;AANJ","sourcesContent":[".itinerary-details-card-wrapper{\n    input {\n        display: none;\n    }\n\n    label {\n        position: relative;\n        cursor: pointer;\n        font-size: 16px;\n        font-weight: 700;\n        letter-spacing: 0.03em;\n    }\n\n    label:before {\n        content: '';\n        appearance: none;\n        -webkit-appearance: none;\n        background-color: transparent;\n        border: 1px solid #c2c2c2;\n        border-radius: 2px;\n        padding: 8px;\n        display: inline-block;\n        position: relative;\n        vertical-align: middle;\n        cursor: pointer;\n    }\n\n    input:checked+label:before {\n        border: 1px solid #92278f;\n    }\n\n    input:checked+label:after {\n        content: '';\n        display: block;\n        position: absolute;\n        top: 3px;\n        left: 7px;\n        width: 5px;\n        height: 10px;\n        border: solid #92278f;\n        border-width: 0 2px 2px 0;\n        transform: rotate(45deg);\n    }\n\n    .route-name{\n        padding-left: 0;\n    }\n}\n\n.itinerary-details-card-wrapper:has(input:checked) {\n    background-color: #f8f7f7!important;\n    border: 1px solid #92278f!important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
